import styled from 'styled-components';
import { StyledArcsProps } from './types';

/**
 * Component style.
 */
export const StyledArcs = styled.g<StyledArcsProps>``;
